import React, { useEffect,useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/businesses/businessesActions";
import * as crud from "../../../_redux/businesses/businessesCrud";

import * as uiHelpers from "../BusinessesUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useBusinessesUIContext } from "../BusinessesUIContext";
import {Modal } from 'react-bootstrap'

export function BusinessesTable() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  var viewer = false;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }
  if (userobject.admin_role && userobject.admin_role === 'viewer' && userobject.is_admin) { viewer = true; }

  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      ids: businessesUIContext.ids,
      setIds: businessesUIContext.setIds,
      queryParams: businessesUIContext.queryParams,
      setQueryParams: businessesUIContext.setQueryParams,
      openEditBusinessPage: businessesUIContext.openEditBusinessPage,
      openDeleteBusinessDialog: businessesUIContext.openDeleteBusinessDialog,
    };
  }, [businessesUIContext]);

  // Getting curret state of businesses list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.businesses }),
    shallowEqual
  );
  const delay = ms => new Promise(res => setTimeout(res, ms));

  const { totalCount, entities, listLoading } = currentState;
  // Businesses Redux state
  const [processing, setProcessing] = useState('');
  const [isShow, setIsShow] = useState(false);

  //for premium modal start
 

  const [loading, setLoading] = useState(false);
  const [expiry, setExpiry] = useState('');
  const [businessId, setBusinessId] = useState('');
  const [is_purchased, setIsPurchased] = useState('');
  const [is_purchasedErr, setIsPurchasedErr] = useState(false);
  const [expiryErr, setExpiryErr] = useState(false);
  const currentDate = new Date().toISOString().slice(0, 10);
 
  //for premium modal ends

  // Categories Redux state
  const dispatch = useDispatch();

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [sendingEmail, setSendingEmail] = useState(false);

  const openSendEmailModal = (businessRow) => {
    setSelectedBusiness(businessRow);
    setEmailSubject("");
    setEmailMessage("");
    setSendingEmail(false);
    setShowEmailModal(true);
  };

  const handleSendEmail = async () => {
    if (!selectedBusiness) return;
    setSendingEmail(true);
    try {
      await crud.sendCustomEmail(selectedBusiness.userid, selectedBusiness.business_email, emailSubject, emailMessage);
      alert("Email sent successfully!");
      setShowEmailModal(false);
    } catch (err) {
      console.error(err);
      alert("Failed to send email. " + (err.response?.data?.message || err.message));
    } finally {
      setSendingEmail(false);
    }
  };

  const updateStatus = async (id, status) => {
    setProcessing(id);
    try {
      await crud.updateStatusForBusiness(id, status);
      await dispatch(actions.fetchBusinesses(businessesUIProps.queryParams));
    } catch (err) {
      console.error(err);
      alert("Failed to update status: " + (err?.response?.data?.message || err?.message));
    } finally {
      setProcessing('');
    }
  };

  const rowStyle = (row) => ({
    ...getRowStyleByStatus(row, "status"),
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    color: "#181C32",
  });
  
  const setExpiryFunction = (value) => {
    if(value!==''){
      setExpiryErr(false)
      setExpiry(value)
    }
  }
 
  const setStatusFunction = (value) => {
    if(value!==''){
      setIsPurchasedErr(false)
      setIsPurchased(value)
    }
    else if(value===''){
      setIsPurchasedErr(true)
      setIsPurchased(value)
    }
  }
  
  const formatDate = (date) =>{
    var d = new Date(parseInt(date)),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }

  const makePremiumFunction = (row) => {
    setExpiry('')
    setIsPurchased('')
    setBusinessId('')
    if(row.expiry!==null){setExpiry(formatDate(row.expiry))}
    setIsPurchased(row.is_purchased)
    setBusinessId(row.id)
    setIsShow(true)
  };
  
  const makePremium = async() => {
    setLoading(true)
    let success = true
    if(expiry===''){ success=false;setExpiryErr(true)}
    if(is_purchased===''){ success=false; setIsPurchasedErr(true)}
    if(businessId===''){ success=false}
    if(success){
      const expiryDateMiliSecond = new Date(expiry).getTime()
      await crud.updateBusinessPremiumStatus(businessId, is_purchased, expiryDateMiliSecond )
      await delay(1500);
      setLoading(false)
      setIsShow(false)
      setExpiry('')
      setBusinessId('')
      setIsPurchased('')
      dispatch(actions.fetchBusinesses(businessesUIProps.queryParams));
    }
    setLoading(false)
  }

  useEffect(() => {
    // clear selections list
    businessesUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchBusinesses(businessesUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessesUIProps.queryParams, dispatch]);

  // Table columns
  let columns = [
    {
      attrs: { title: 'Business' },
      dataField: "name",
      text: "Business",
      formatter: (cell, row) => {
        return (
          <div className="d-flex flex-column py-1">
            <div className="d-flex align-items-center flex-wrap">
              <span className="font-weight-bolder text-dark font-size-sm mr-2">{row.name}</span>
              {row.is_purchased && (
                <span
                  className="font-weight-bolder px-2 py-0"
                  style={{
                    backgroundColor: "#fff4de",
                    color: "#b45309",
                    border: "1px solid #fcd34d",
                    fontSize: "10px",
                    borderRadius: "4px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  <i className="fa fa-crown mr-1" style={{ color: "#d97706", fontSize: "10px" }}></i>
                  Premium
                </span>
              )}
            </div>
            {row.business_email && (
              <span className="text-muted font-size-xs mt-1" style={{ lineHeight: 1.2 }}>
                <i className="fa fa-envelope mr-1 opacity-50" style={{ fontSize: "10px" }}></i>
                {row.business_email}
              </span>
            )}
          </div>
        );
      },
      classes: "align-middle",
      headerClasses: "align-middle text-nowrap",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Approved By' },
      dataField: "approved_by_name",
      text: "Approved By",
      formatter: (cell, row) => {
        if (row.approved_by_name) {
          return (
            <span className="font-weight-bold text-dark d-inline-flex align-items-center">
              <i className="fa fa-user-shield text-primary mr-1 font-size-xs"></i>
              {row.approved_by_name}
            </span>
          );
        }
        return <span className="text-muted font-size-xs font-weight-bold">—</span>;
      },
      classes: "align-middle text-nowrap",
      headerClasses: "align-middle text-nowrap",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Updated At' },
      dataField: "status_updated_date",
      text: "Updated At",
      formatter: (cell, row) => {
        const rawDate = row.status_updated_date || row.createdAt;
        if (!rawDate) return <span className="text-muted font-size-xs">—</span>;
        try {
          const timestamp = typeof rawDate === "number" || !isNaN(rawDate) ? parseInt(rawDate, 10) : rawDate;
          const d = new Date(timestamp);
          if (isNaN(d.getTime())) return <span className="text-muted font-size-xs">—</span>;
          const dateStr = d.toISOString().slice(0, 10);
          const timeStr = ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
          return (
            <div className="d-flex flex-column py-1">
              <span className="font-weight-bolder text-dark font-size-xs">{dateStr}</span>
              <span className="text-muted font-size-xs">{timeStr}</span>
            </div>
          );
        } catch (e) {
          return <span className="text-muted font-size-xs">—</span>;
        }
      },
      classes: "align-middle text-nowrap",
      headerClasses: "align-middle text-nowrap",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Status' },
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        processing: processing,
        superadmin: superadmin,
      },
      classes: "align-middle text-nowrap media-action-class",
      headerClasses: "align-middle text-nowrap",
      sort: true,
      sortCaret: sortCaret,
    },
  ];

  if(!viewer)
  {
    columns.push({
      attrs: { title: 'Actions' },
      dataField: "id",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditBusinessPage: businessesUIProps.openEditBusinessPage,
        makePremiumFunction: makePremiumFunction,
        openSendEmailModal: openSendEmailModal,
      },
      classes: "align-middle text-nowrap text-right pr-3",
      headerClasses: "align-middle text-nowrap text-right pr-3",
      style: {
        minWidth: "120px",
      },
    })
  }

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: businessesUIProps.queryParams.pageSize,
    page: businessesUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="custom-res-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                rowStyle={ rowStyle } 
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  businessesUIProps.setQueryParams
                )}
                selectRow={
                  !viewer
                    ? getSelectRow({
                  entities,
                  ids: businessesUIProps.ids,
                  setIds: businessesUIProps.setIds,
                      })
                    : undefined
                }
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>

      <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Custom Email to {selectedBusiness?.name || "Business"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label className="font-weight-bold">To</label>
            <input
              type="text"
              className="form-control bg-light"
              value={selectedBusiness?.business_email || ""}
              disabled
            />
          </div>
          <div className="form-group mt-3">
            <label className="font-weight-bold text-dark">Subject</label>
            <input
              type="text"
              className="form-control border-secondary"
              placeholder="Enter email subject..."
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            />
          </div>
          <div className="form-group mt-3">
            <label className="font-weight-bold text-dark">Message</label>
            <textarea
              className="form-control border-secondary"
              rows="5"
              placeholder="Type your custom message here..."
              value={emailMessage}
              onChange={(e) => setEmailMessage(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowEmailModal(false)}
            disabled={sendingEmail}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSendEmail}
            disabled={sendingEmail || !emailSubject.trim() || !emailMessage.trim()}
          >
            {sendingEmail ? (
              <>
                <i className="fas fa-circle-notch fa-spin mr-2"></i> Sending...
              </>
            ) : (
              "Send Email"
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal centered size="md" show={isShow} onHide={(event) => setIsShow(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Update Business Premium Status </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
            <div className="form-group row">
              <div className="col-lg-12 mb-3">
                <label>Select Premium Status</label>
                <select
                  className="form-control"
                  name="is_purchased"
                  value={is_purchased}
                  onChange={(e) => {
                    setStatusFunction(e.target.value);
                  }}
                >
                  <option value="">Select Premium Status </option>
                  <option value="false">Free</option>
                  <option value="true" >Premium</option>
                </select>
                {(is_purchasedErr) ? <div className="invalid-feedback">Field required</div> : <></>}
              </div>

              <div className="col-lg-12 mb-3">
                <label>Expiry Date</label>
                <input type="date" value={expiry} min={currentDate} onChange={(e) => { setExpiryFunction(e.target.value); }} className={(expiryErr)? 'form-control is-invalid' : 'form-control'}  name="expiry" />
                {(expiryErr) ? <div className="invalid-feedback">Invalid Date</div> : <></>}
              </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="py-2 d-block">
          <button type="button" className="btn btn-secondary float-left" onClick={() => setIsShow(false)}><i className="fa fa-arrow-left"></i>Cancel</button>
          <button type="button" className="btn btn-primary float-right" onClick={() => makePremium()}>{(loading) ? <i className="fa fa-spinner"></i> :'Update'}</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}